import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes } from 'mobx-react'
import { forgotPassword } from '../api'
import Input from './Input'
import 'formdata-polyfill'
import object_value from '../api/object_value'
import return_html from '../api/return_html'

@inject('user', 'modals')
@observer
class ForgotPasswordForm extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      form_class: 'b-form',
      status: '',
      message: ''
    }
  }

  // Enable browser form validation on any input change
  makeValidationVisible = () => {
    // Make validation errors visible
    if (this.state.form_class === 'b-form') {
      this.setState({form_class: this.state.form_class + ' b-form_allow-browser-validation'})
    }
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleInput = async () => {
    this.setState({status: ''})
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleSubmit = async (event) => {
    event.preventDefault()

    this.setState({status: 'loading'})

    const data = new FormData(event.target)
    // Display the key/value pairs
    console.log('handleSubmit() - data')
    for (let [key, val] of data.entries()) {
      console.log(key, val)
    }

    // Send a request
    let response = await forgotPassword(data)
    console.log('handleSubmit() - response', response)

    // Error
    if (!response.ok) {
      if (this.refs.ForgotPasswordForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message: object_value(response, 'data.message', 'Error')
        })
      }

      return false
    }

    let token = object_value(response, 'data.token')
    let message
    if (token) {
      let url = window.location.origin + '/ResetPassword?token=' + token
        // message = '<a class="b-link b-link_underline" href="'+ url +'">Proceed to reset</a>'
        message = `We’ve sent you an e-mail to reset your password. <br /> Please follow the instructions`
    }

    // Success
    if (this.refs.ForgotPasswordForm) {
      this.setState({
        status: 'success',
        message
      })
    }
  }

  handleOnclickCloseModal = (event) => {
    event.preventDefault()

    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    this.props.modals.setModal('')
  }

  render () {
    return (
      <form ref="ForgotPasswordForm"
            className={this.state.form_class}
            onInput={this.handleInput}
            onSubmit={this.handleSubmit}>

        {(this.state.status === '' || this.state.status === 'error') &&
        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='email'
                   name='email'
                   type='email'
                   required
            />
            <label className='b-form-item-label'
                   htmlFor='email'>
              {intl.get('E-Mail')}
            </label>
          </div>
        </div>}

        {this.state.status === 'loading' &&
        <div className='b-form-success'>{intl.get('Loading')}...</div>}

        {this.state.status === 'error' &&
        <div className='b-form-error'>{this.state.message}</div>}

        {this.state.status !== 'success' &&
        <div className='b-form-row'>
          <button type='submit'
                  className='b-button b-button_primary b-button_x'
                  onClick={this.makeValidationVisible}>
            {intl.get('Submit')}
          </button>
        </div>}

        {this.state.status === 'success' &&
        <div>
          <div className='b-form-success'
               dangerouslySetInnerHTML={return_html(this.state.message)} />

          <div className='b-form-row'>
            <button type='submit'
                    className='b-button b-button_primary b-button_x'
                    onClick={this.handleOnclickCloseModal}>
              {intl.get('OK')}
            </button>
          </div>
        </div>}
      </form>
    )
  }
}

ForgotPasswordForm.propTypes = {
  location: PropTypes.objectOrObservableObject,
  modals: PropTypes.observableObject
}

export default ForgotPasswordForm



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm.js